import { ParsedUrlQuery } from 'querystring';

export const getRoute = (query: { [k: string]: string; } | ParsedUrlQuery) => {
  if ((Array.isArray(query.gclid) ? query.gclid.pop() : query.gclid) || query.utm_source === "google") {
    return "a";

  } else if ((Array.isArray(query.fbclid) ? query.fbclid.pop() : query.fbclid) || query.utm_source === "fb" || query.utm_source === "ig") {
    return "f";

  } else if (Array.isArray(query.msclkid) ? query.msclkid.pop() : query.msclkid) {
    return "b";

  } else if (Array.isArray(query.twclid) ? query.twclid.pop() : query.twclid) {
    return "t";

  } else if (Array.isArray(query.ttclid) ? query.ttclid.pop() : query.ttclid) {
    return "k";

  } else if (Array.isArray(query.adid) ? query.adid.pop() : query.adid) {
    return "s";

  } else {
    return "o";
  }
};